/**
 * 目標配置と、その達成判定。
 *
 * 本作の 2 段階構成は「段階ごとに別のロジックを持つ」のではなく、**目標配置 `target` を
 * 差し替えるだけ**で表現される。第 1 段階は秘文字の目標配置 `τ`、第 2 段階は恒等写像 `id`。
 * 結合もクリア判定も `target` を引数に取るため、段階の分岐は core に存在しない。
 *
 * 根拠: spec/04a-puzzle-core.md §1.4 / §4 / §5、ADR-005。
 */

import type { PositionOf, TargetLayout } from './types';

export type { TargetLayout } from './types';

/**
 * 第 2 段階の目標配置 `id`（`target[p] = p`）。
 *
 * ピース `p` が原画像のセル `p` の断片であるという定義（`04a` §1.2）から、正解画像の配置は
 * 恒等写像になる。
 */
export const IDENTITY_TARGET = (N: number): TargetLayout =>
  Array.from({ length: N }, (_, piece) => piece);

/**
 * すべてのピースが目標のセルにいるか。
 *
 * 第 1 段階のクリアは `isSolved(positionOf, τ)`、第 2 段階は `isSolved(positionOf, id)` で
 * 判定する。判定する側は自分がどちらの段階にいるかを知らなくてよい。
 *
 * 「グループ数が 1」による同値判定（`04a` §4）もあるが、こちらは `computeGroups` を必要と
 * しないぶん安く、段階遷移の検出に使う。
 */
export function isSolved(positionOf: PositionOf, target: TargetLayout): boolean {
  if (positionOf.length !== target.length) return false;
  for (const [piece, cell] of target.entries()) {
    if (positionOf[piece] !== cell) return false;
  }
  return true;
}
